/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Returns `true` when the LG shell app set `freshInstall=true` on the
 * iframe URL — indicating an uninstall/reinstall was detected.
 */
export function isFreshInstallLaunch(): boolean {
    const params: URLSearchParams = new URLSearchParams(window.location.search);
    return params.get('freshInstall') === 'true';
}
